import Api from "@/api/Api";
import errorHandler from "@/utils/plugins/ErrorHandler";

const RESOURCE_TRACKER = "/api/courses";

export default {
  async getCourses(params) {
    return await Api()
      .get(RESOURCE_TRACKER, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  async createCourse(params) {
    return Api()
      .post(RESOURCE_TRACKER, params)
      .catch((err) => errorHandler(err, null));
  },
  async updateCourse(id, params) {
    return Api()
      .put(`${RESOURCE_TRACKER}/${id}`, params)
      .catch((err) => errorHandler(err, null));
  },
  async getCourse(id, params) {
    return Api()
      .get(`${RESOURCE_TRACKER}/${id}`, params)
      .catch((err) => errorHandler(err, null));
  },
  async discardCourse(id) {
    return Api()
      .delete(`${RESOURCE_TRACKER}/${id}`)
      .catch((err) => errorHandler(err, null));
  },
};
